import '@/assets/scss/iconfont/iconfont.css';
import Vue from 'vue';
import App from './App.vue';
import router from '@/vue/router/';
import Vuex from 'vuex'
import store from './vue/vuex/store'

import 'babel-polyfill'


import axios from '@/vue/plugins/axios';
import util from '@/assets/js/util';
import filters from "@/vue/filter/";
import 'font-awesome/css/font-awesome.css'
import weiXin from "@/assets/js/WeiXin.js"
import mixin from '@/vue/mixin/mixin';
import hiddenNavMixin from '@/vue/mixin/hidden-nav-mixin';

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import nav2 from '@/vue/components/nav2'
import dragImgUpload from '@/vue/components/dragImgUpload'
import wxChat from '@/vue/components/wxChat'


import vuescroll from 'vuescroll';
import 'vuescroll/dist/vuescroll.css';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import plugIn from "@/vue/components/plugIn/"

import RTF from "@/vue/components/RTF/index.vue"

import treeSelect from "@/vue/components/treeSelect/treeSelect.vue"
import VCharts from 'v-charts'

Vue.component("v-rtf",RTF)
Vue.component("v-nav",nav2)
Vue.component("v-drag-img-upload",dragImgUpload)
Vue.component("wxChat",wxChat)
Vue.component("v-tree-select",treeSelect)

Vue.use(plugIn);
Vue.use(vuescroll);
Vue.use(Viewer);

Vue.mixin(mixin)
Vue.mixin(hiddenNavMixin)
Vue.use(VCharts)

Vue.config.debug = true;
Vue.config.devtools = true

// plugins
Vue.use(axios);

// vue
Vue.use(weiXin);
Vue.use(filters);
Vue.use(util);
Vue.use(Vuex);

// ElementUI
Vue.use(ElementUI)


new Vue({
    el: '#app',
    router,
    store,
    created() {

    },
    render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js